import * as React from "react";
import { Popover as PopoverPrimitive } from "radix-ui";

import { cn } from "storefront/ui/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverArrow = PopoverPrimitive.Arrow;

export interface PopoverContentProps
  extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
  matchTriggerWidth?: boolean;
  matchTriggerHeight?: boolean;
}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(
  (
    {
      className,
      align = "center",
      sideOffset = 4,
      matchTriggerWidth = false,
      matchTriggerHeight = false,
      key,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        key={String(key)}
        className={cn(
          "z-[350] bg-white p-[16px] text-primary drop-shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          matchTriggerWidth &&
            "data-[side=top]:w-[var(--radix-popover-trigger-width)] data-[side=bottom]:w-[var(--radix-popover-trigger-width)]",
          matchTriggerHeight &&
            "data-[side=left]:h-[var(--radix-popover-trigger-height)] data-[side=right]:h-[var(--radix-popover-trigger-height)]",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor, PopoverArrow };
